import React from 'react'
import { makeStyles } from '@material-ui/core'
import Button from "@material-ui/core/Button"
import { useHistory } from 'react-router-dom'

const useStyles = makeStyles(theme=>({
    buttons:{
        width:'50%',
        margin:'0 auto',
        display:'grid',
        gridTemplateColumns:'1fr 1fr',
        gridGap:theme.spacing(1)
    }
}))

const AnonymousCall = ({mobilePhone}) => {
    const classes = useStyles();
    const history = useHistory();

    const handleAddCustomer = ()=>{
        history.push('/protected/admin/users/add/customer',{mobilePhone});
    }
    const handleAddDriver = ()=>{
        history.push('/protected/admin/users/add/driver',{mobilePhone});
    }
  return (
    <>
        <div>تماس ناشناس</div>
        <div className={classes.buttons}>
            <Button variant="text" color="secondary" onClick={handleAddCustomer}>صاحب بار</Button>    
            <Button variant="text" color="secondary" onClick={handleAddDriver}>راننده</Button>    
        </div>
    </>
  )
}

export default AnonymousCall